import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/chat",
    name: "chat",
    meta: { requiresLogin: true },
    component: () => import ("../views/chat"),
  },
  {
    path: "/setting",
    name: "setting",
    meta: { requiresLogin: true },
    component: () => import ("../views/setting/index"),
  },
  {
    path: "/teacher/evaluations",
    name: "teacher/evaluations",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/evaluations"),
  },
  {
    path: "/student/evaluaciones/review",
    name: "evaluation-review",
    props : true,
    meta: { requiresLogin: true },
    component: () => import ("../views/student/evaluaciones/revision"),
  },
  {
    path: "/student/evaluaciones/file-upload",
    name: "evaluation-file-upload",
    meta: { requiresLogin: true, profile:"student" },
    props : true,
    component: () => import ("../views/student/evaluaciones/file-upload"),
  },
  {
    path: "/teacher/evaluations/file-upload",
    name: "evaluation-teacher-file-upload",
    meta: { requiresLogin: true, profile:"teacher" },
    props : true,
    component: () => import ("../views/teacher/evaluations/file-upload"),
  },
  {
    path: "/student/evaluaciones",
    name: "student/evaluaciones",
    props : true,
    meta: { requiresLogin: true, profile:"student" },
    component: () => import ("../views/student/evaluaciones"),
  },
  {
    path: "/teacher/student/evaluations-reports/:id/view-report",
    name: "teacher/student/evaluations-reports/view-report",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/student/view-report"),
  },
  {
    path: "/student/evaluations-reports/view-report",
    name: "student/evaluations-reports/view-report",
    meta: { requiresLogin: true, profile:"student" },
    component: () => import ("../views/student/evaluations-reports/view-report"),
  },
  {
    path: "/student/evaluations-reports",
    name: "student/evaluations-reports",
    meta: { requiresLogin: true, profile:"student" },
    component: () => import ("../views/student/evaluations-reports"),
    
  },
  {
    path: "/teacher/student/evaluations-reports/:id/evaluations-review",
    name: "teacher-student-evaluations-reports-evaluations-review",
    props:true,
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/student/evaluations-review"),
  },
  {
    path: "/teacher/student/evaluations-reports/:id",
    name: "teacher-student-evaluations-reports",
    props:true,
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/student/evaluations-reports"),
  },
  {
    path: "/teacher/student",
    name: "teacher/student",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/student"),
    props: true
  },
  {
    path: "/teacher/schedule",
    name: "teacher/schedule",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/schedule"),
  },
  /*{
    path: "/faqs",
    name: "faqs",
    component: () => import ("../views/faqs"),
  },*/
  {
    path: "/faqs",
    name: "faqs",
    component: () => import ("../views/student/faqs"),
  },
  {
    path: "/teacher/faqs",
    name: "teacher/faqs",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/faqs"),
  },
  {
    path: "/",
    name: "login",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/index"),
  },
  {
    path: "/teacher/login",
    name: "teacher/login",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/loginTeacher"),
  },
  {
    path: "/student/login",
    name: "student/login",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/login"),
  },
  {
    path: "/student/register",
    name: "register",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/register-student"),
  },
  {
    path: "/teacher/register",
    name: "registerTeacher",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/register-teacher"),
  },
  {
    path: "/teacher/password/account",
    name: "teacher-account-password",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/accounts/AccountTeacher"),
  },
  {
    path: "/teacher/account",
    name: "teacher-account",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/account"),
  },
  {
    path: "/student/account",
    name: "student-account",
    meta: { requiresLogin: true, profile:"student" },
    component: () => import ("../views/accounts/AccountStudent"),
  },
  {
    path: "/student/account/information",
    name: "student-account-information",
    meta: { requiresLogin: true, profile:"student" },
    component: () => import ("../views/student/account"),
  },
  {
    path: "/reset-password/:key",
    name: "reset-password",
    meta: { layout: "auth" },
    component: () =>
        import ("../views/auth/ResetPassword"),
  },
  {
    path: "/register-password/:key",
    name: "register-password",
    meta: { layout: "auth" },
    component: () =>
        import ("../views/auth/RegisterPassword"),
  },
  {
    path: "/student/dashboard",
    name: "dashboard",
    component: () => import ("../views/student/dashboard"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/teacher/dashboard",
    name: "teacher/dashboard",
    component: () => import ("../views/teacher/dashboard"),
    meta: { requiresLogin: true, profile:"teacher" },
  },
  {
    path: "/edad",
    name: "edad",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/edad"),
  },
  {
    path: "/compra/:step",
    name: "compra",
    meta: { layout: "default" },
    component: () => import ("../views/compra"),
  },
  {
    path: "/compra/:step/:transaction",
    name: "compratransaction",
    meta: { layout: "default" },
    component: () => import ("../views/compra"),
  },
  {
    path: "/horario",
    name: "horario",
    component: () => import ("../views/student/horario"),
    props: true,
    meta: { requiresLogin: true, requiresPlan:true, profile:"student" },
   
  },
  {
    path: "/horario/calendario",
    name: "horario-calendario",
    component: () => import ("../views/student/horario/calendario"),
    props: true,
    children: [
      {
        path: ':id',
      
        component: () => import ("../views/student/horario/calendario"),
       
      }
    ],
    meta: { requiresLogin: true, profile:"student", requirePlanActive: true }
  },
  {
    path: "/horario/clases",
    name: "horario-calendario-clases",
    component: () => import ("../views/student/horario/class-calendar"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/teacher/wallet",
    name: "teacher-wallet",
    component: () => import ("../views/teacher/wallet"),
    meta: { requiresLogin: true, profile:"teacher" }
  },
  {
    path: "/teacher/class-request",
    name: "teacher-class-request",
    component: () => import ("../views/teacher/class-request"),
    props: true,
    children: [
      {
        path: ':type',
        component: () => import ("../views/teacher/class-request"),
      }
    ],
    meta: { requiresLogin: true, profile:"teacher" }
  },
  {
    path: "/calendar-demo",
    name: "calendar-demo",
    component: () => import ("../views/student/horario/calendar-demo"),
  },
  {
    path: "/cursos-test",
    name: "calendar-test",
    component: () => import ("../views/compra/cursos-test"),
  },
  {
    path: "/cursos/:index?",
    name: "cursos",
    meta: { requiresLogin: true, profile:"student" },
    component: () => import ("../views/cursos"),
  },
  // {
  //   path: "/cursos",
  //   name: "cursos",
  //   meta: { requiresLogin: true, profile:"student" },
  //   component: () => import ("../views/cursos"),
  // },
  {
    path: "/faq",
    name: "faq",
    component: () => import ("../views/public/faq"),
  },
  {
    path: "/materials/:a*",
    name: "materials",
    component: () => import ("../views/materials"),
    meta: { requiresLogin: true }
  },
  {
    path: "/evaluacion-nivel",
    name: "evaluacion-nivel",
    component: () => import ("../views/student/evaluacion/index"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/student/class",
    name: "student-class",
    component: () => import ("../views/student/class"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/teacher/class",
    name: "teacher-class",
    props:true,
    component: () => import ("../views/teacher/class"),
    meta: { requiresLogin: true, profile:"teacher" }
  },
  {
    path: "/teacher/class/class-report",
    name: "teacher-class-list-report",
    props:true,
    component: () => import ("../views/teacher/class/class-report"),
    meta: { requiresLogin: true, profile:"teacher" }
  },
  {
    path: "/teacher/class/class-report/report/:id/:classId",
    name: "teacher-class-report",
    component: () => import ("../views/teacher/class/report"),
    meta: { requiresLogin: true, profile:"teacher" }
  },
  {
    path: "/teacher/class/intermediate/:key",
    name: "teacher-class-intermediate",
    component: () => import ("../views/teacher/class/intermediate"),
    meta: { requiresLogin: true, profile:"teacher" }
  },
  {
    path: "/student/class/report/:id",
    name: "student-class-report",
    component: () => import ("../views/student/class/report-class"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/student/class/intermediate/:key",
    name: "student-class-intermediate",
    component: () => import ("../views/student/class/intermediate"),
    meta: { requiresLogin: true,  profile:"student"  }
  },
  {
    path: "/admin/login",
    name: "admin/login",
    meta: { layout: "auth" },
    component: () => import ("../views/auth/loginAdmin"),
  },
  {
    path: "/student/historial-compras",
    name: "student-historial-compras",
    component: () => import ("../views/student/historial/compras"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/student/historial-cursos",
    name: "student-historial-cursos",
    component: () => import ("../views/student/historial/cursos"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/teacher/student/courseHistory",
    name: "teacher-student-courseHistory",
    meta: { requiresLogin: true, profile:"teacher" },
    component: () => import ("../views/teacher/student/courseHistory"),
  },
  {
    path: "/student/avances",
    name: "student-avances",
    component: () => import ("../views/student/avances"),
    meta: { requiresLogin: true, profile:"student" }
  },
  {
    path: "/exam",
    name: "exam",  
    meta: { layout: 'blank' },
    component: () => import ("../views/exam"),
  },
  {
    path: "/exam/:lang",
    name: "exam",
    meta: { layout: 'blank' },
    props:true, 
    component: () => import ("../views/exam"),
  },
  {
    path: "/icons",
    name: "icons",
    component: () => import ("../views/iconsPage"),
  },
  {
    path: "/horario/clases-merge",
    name: "horario-calendario-clases-merge",
    component: () => import ("../views/student/horario/class-calendar-merge"),
    meta: { requiresLogin: true, profile:"student" }
  },

  /*{
    path: "/exam",
    name: "exam",
    component: () => import ("../views/public/exam") 
  },*/
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});


router.beforeEach((to, from, next) => {
  //console.log("Entre al router.beforeEach | to: " + to + " from: " + from)

  let user = store.state.user;
  let is_teacher = store.state.is_teacher;
  
  //console.log("to: " + JSON.stringify(to))
  //console.log("from: " + JSON.stringify(from))

  if(to.matched.length == 0 && to.fullPath != "/"){
    let name = 'compra';
    if(user != null){
      name = is_teacher ? 'teacher/dashboard' : 'dashboard';
    }
    next({ name: name }) 
  }

  if (to.matched.some(record => record.meta.requiresLogin)) {
    
    if(to.meta.profile == "student" && user == null){
      next({ name: 'student/login' });
    }else if(to.meta.profile == "student" && (user != null && is_teacher)){
      next({ name: 'teacher/dashboard' });
    }else if(to.meta.profile == "teacher" && user == null){
   
      next({ name: 'teacher/login' });
    }else if(to.meta.profile == "teacher" && (user != null && !is_teacher)){
      next({ name: 'dashboard' });
    }else if(user == null){
      next({ name: 'compra' });
    }else if((to.meta.requirePlanActive != undefined) && !is_teacher && !store.state.datosSidebar.flagActivePlan){
      router.go(-1);
    }else {
      next()
    }
  } else {
    next()
  }
})


export default router;
